// Calendly
window.addEventListener("DOMContentLoaded", function() {
  const links = document.querySelectorAll('a[href*="#"]');

  for(const link of links) {
    const modalID = link.href.split('#')[1];
    const targetModal = document.querySelector(`.calendly--block[data-modal-id="${modalID}"]`);

    if(!targetModal) {
      continue
    }

    link.addEventListener("click", function(e) {
      e.preventDefault();
      targetModal.closest("rao-calendly").selectModal(modalID);
    });
  }
});

class RAOCalendly extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const buttons = this.querySelectorAll(".calendly--button");
    const blocks  = this.querySelectorAll(".calendly--block");

    for(const button of buttons) {
      button.addEventListener("click", this.selectBlock.bind(this, parseInt(button.dataset.index)));
    }
  }

  selectBlock(blockIndex) {
    const selectedButton = this.querySelector(".calendly--button.selected");
    const selectedBlock  = this.querySelector(".calendly--block.selected");

    if(selectedButton) {
      selectedButton.classList.remove("selected");
    }
    if(selectedBlock) {
      selectedBlock.classList.remove("selected");
    }

    const targetButton = this.querySelector(`.calendly--button[data-index="${blockIndex}"]`);
    const targetBlock  = this.querySelector(`.calendly--block[data-index="${blockIndex}"]`);

    if(!targetButton || !targetBlock) {
      console.error(`There is no block with this index [${blockIndex}]`);
      return
    }

    targetButton.classList.add("selected");
    targetBlock.classList.add("selected");

    this.style.setProperty("--transform-amount", `${-1 * blockIndex * 100}%`);
  }

  selectModal(modalID) {
    const targetBlock = this.querySelector(`.calendly--block[data-modal-id="${modalID}"]`);
    if(!targetBlock) {
      console.error(`There is no block with this modalID [${modalID}]`);
      return
    }

    this.selectBlock(parseInt(targetBlock.dataset.index));
    this.closest("rao-modal").show();
  }
}

customElements.define("rao-calendly", RAOCalendly);

// Price Table
class PriceTable extends HTMLElement {
  #formatter = new Intl.NumberFormat(Shopify.locale, { style: "currency", currency: Shopify.currency.active });

  constructor() {
    super();
  }

  async connectedCallback() {
    const resp = await(await fetch("https://vintage.abris.workers.dev/")).json();
    
    const updateDate = new Date(resp.updated_at);
    const goldPrice = resp.prices.gold.website_price_per_gram;
    const silverPrice = resp.prices.silver.website_price_per_gram;

    const goldPrices = this.querySelectorAll("[data-gold-amount]");
    this.loadGoldPrices(goldPrices, goldPrice);

    const silverPrices = this.querySelectorAll("[data-silver-amount]");
    this.loadSilverPrices(silverPrices, silverPrice);

    const lastRefreshEl = this.querySelector("[data-last-refresh-text]");
    this.loadDate(lastRefreshEl, updateDate);

    this.classList.add("loaded");
  }

  loadDate(el, date) {
    const text = el.dataset.lastRefreshText;
    const formattedText = this.#formatDateText(text, date);
    console.log(formattedText);

    el.innerText = formattedText;
  }

  loadGoldPrices(elements, unitPrice) {
    for(const el of elements) {
      const amount = parseInt(el.dataset.goldAmount);
      const price = this.getPrice(amount, unitPrice);

      el.innerText = this.#formatPrice(price);
    }
  }

  loadSilverPrices(elements, unitPrice) {
    for(const el of elements) {
      const amount = parseInt(el.dataset.silverAmount);
      const price = this.getPrice(amount, unitPrice);

      el.innerText = this.#formatPrice(price);
    }
  }

  getPrice(amount, unitPrice) {
    return (amount / 1000 * unitPrice).toFixed(2);
  }

  #formatDateText(text, date) {
    text = text.replace("%d", String(date.getDate()).padStart(2, "0"));
    text = text.replace("%m", String(date.getMonth() + 1).padStart(2, "0"));
    text = text.replace("%b", date.toLocaleString(Shopify.locale, {month: "short"}));
    text = text.replace("%B", date.toLocaleString(Shopify.locale, {month: "long"}));
    text = text.replace("%H", String(date.getHours()).padStart(2, "0"));
    text = text.replace("%M", String(date.getMinutes()).padStart(2, "0"));

    return text;
  }

  #formatPrice(value) {
    return this.#formatter.format(value).replace(/\s(?=\d)/, "");
  }
}

customElements.define("price-table", PriceTable);


/* Dynamic Breadcrumb Links */
function toHex(str) {
  return Array.from(str).map(c => c.charCodeAt(0).toString(16).padStart(2, "0")).join("");
}

/*window.addEventListener("DOMContentLoaded", function() {
  const productCards = document.querySelectorAll("product-card");

  if(productCards.length != 0) {
    const breadcrumbs = document.querySelector(".breadcrumb__list");

    if(breadcrumbs) {
      for(const productCard of productCards) {
        for(const breadcrumbLink of productCard.querySelectorAll(".product-card--breadcrumbs-link")) {
          let href = breadcrumbLink.getAttribute("href");

          if(href.includes("?")) {
            href += `&breadcrumbs=${toHex(breadcrumbs.outerHTML)}`;
          } else {
            href += `?breadcrumbs=${toHex(breadcrumbs.outerHTML)}`;
          }

          breadcrumbLink.setAttribute("href", href);
        }
      }
    }
  }
});*/

class RAOBreadcrumbs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handle = this.dataset.handle;
    const breadcrumbItems = this.getBreadcrumbsFromSession(handle);

    if(breadcrumbItems.length != 0) {
      this.buildBreadcrumbs(breadcrumbItems)
    } else {
      this.classList.add("show");
    }
  }

  getBreadcrumbsFromSession(handle) {
    const breadcrumbsMap  = localStorage.getItem("breadcrumbs") ? new Map(JSON.parse(localStorage.getItem("breadcrumbs"))) : null;
    if(breadcrumbsMap) {
      const breadcrumbsItem = breadcrumbsMap.get(handle);

      if(breadcrumbsItem && new Date(breadcrumbsItem.createdAt).setHours(24) < new Date()) {
        return "";
      }

      return breadcrumbsItem ? breadcrumbsItem.items : [];
    }

    return [];
  }

  decode(hexStr) {
    const bytes = Uint8Array.fromHex(hexStr);

    return new TextDecoder().decode(bytes);
  }

  buildBreadcrumbs(items) {
    const breadcrumbsHTML = "";
    const breadcrumbsParentTemp = this.querySelector(".breadcrumb__list");
    const breadcrumbsParent = breadcrumbsParentTemp.cloneNode(false);
    const breadcrumbsItemTemp   = this.querySelector(".breadcrumb__list-item");

    for(const item of items) {
      const breadcrumbsItem = breadcrumbsItemTemp.cloneNode(true);
      const breadcrumbsLink = breadcrumbsItem.querySelector("a");

      breadcrumbsLink.setAttribute("href", item.link);
      breadcrumbsLink.innerText = item.title;

      breadcrumbsParent.appendChild(breadcrumbsItem);
    }

    this.innerHTML = breadcrumbsParent.outerHTML;
    this.classList.add("show");
  }
}

customElements.define("rao-breadcrumbs", RAOBreadcrumbs);

class RAOModal extends HTMLElement {
  constructor() {
    super();
  }

  show() {
    this.classList.add("show");
    document.documentElement.classList.add("lock");
  }

  hide() {
    this.classList.remove("show");
    document.documentElement.classList.remove("lock");
  }
}

customElements.define("rao-modal", RAOModal);

class AppointmentModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const openButton = this.querySelector(".product-info__appointment_button");
    if(openButton) {
      openButton.addEventListener("click", this.open.bind(this));
    }

    const overlay = this.querySelector(".appointment--overlay");
    if(overlay) {
      overlay.addEventListener("click", this.close.bind(this));
    }

    const closeButton = this.querySelector(".appointment__modal--close");
    if(closeButton) {
      closeButton.addEventListener("click", this.close.bind(this));
    }

    this.onlineButton = this.querySelector(".appointment__modal--header-online-button");
    this.inStoreButton = this.querySelector(".appointment__modal--header-store-button");

    if(this.onlineButton) {
      this.onlineButton.addEventListener("click", this.onlineView.bind(this));
    }
    if(this.inStoreButton) {
      this.inStoreButton.addEventListener("click", this.storeView.bind(this));
    }
  }

  onlineView() {
    this.classList.remove("store-view");
    this.onlineButton.classList.add("button--active");
    this.inStoreButton.classList.remove("button--active");
  }

  storeView() {
    this.classList.add("store-view");
    this.onlineButton.classList.remove("button--active");
    this.inStoreButton.classList.add("button--active");
  }

  open() {
    this.classList.add("show-appointment-modal");
    document.querySelector(".product-info").classList.add("in-front");
    document.documentElement.classList.add("lock");
  }

  close() {
    this.classList.remove("show-appointment-modal");
    document.querySelector(".product-info").classList.remove("in-front");
    document.documentElement.classList.remove("lock");
  }
}

customElements.define("appointment-modal", AppointmentModal);

class RAODropdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button  = this.querySelector(".dropdown--button");
    this.content = this.querySelector(".dropdown--content");
    this.inner   = this.querySelector(".dropdown--inner");
    const items  = this.querySelectorAll(".dropdown--item");
    this.error   = this.querySelector(".ring-size-selector--error");

    this.button.addEventListener("click", this.toggleButton.bind(this));

    for(const item of items) {
      item.addEventListener("click", this.itemSelect.bind(this, item));
    }
  }

  itemSelect(item) {
    const selectedItem = this.inner.querySelector(".selected");
    if(selectedItem) {
      selectedItem.classList.remove("selected");
    }

    this.button.querySelector(".dropdown--value").innerText = item.querySelector(".dropdown--item-label").innerText;
    this.button.classList.add("item-selected");

    this.error.classList.remove("show");
    
    this.toggleButton();

    item.classList.add("selected");
  }

  toggleButton() {
    this.content.style.setProperty("--inner-height", `${this.inner.getBoundingClientRect().height}px`);
    this.classList.toggle("open");
  }
}

customElements.define("rao-dropdown", RAODropdown);

// Countdown Timer
class CountdownTimer {
  constructor(element) {
    this.element = element;
    this.useOneTime = element.dataset.useOneTime === 'true';
    this.oneTimeDate = element.dataset.oneTimeDate;
    this.useLooping = element.dataset.useLooping === 'true';
    this.loopingDay = parseInt(element.dataset.loopingDay);
    this.loopingHour = parseInt(element.dataset.loopingHour);
    
    this.daysEl = element.querySelector('[data-days]');
    this.hoursEl = element.querySelector('[data-hours]');
    this.minutesEl = element.querySelector('[data-minutes]');
    this.secondsEl = element.querySelector('[data-seconds]');
    
    this.updateCountdown();
    this.intervalId = setInterval(() => this.updateCountdown(), 1000);
  }

  getTargetDate() {
    const now = new Date();

    if (this.useOneTime && this.oneTimeDate) {
      return this.parseOneTimeDate(this.oneTimeDate);
    }

    if (this.useLooping) {
      return this.getNextLoopingDate();
    }

    return null;
  }

  parseOneTimeDate(dateStr) {
    // Format: "MM-DD-HH" (e.g., "02-05-09")
    const [month, day, hour] = dateStr.split('-').map(Number);
    
    if (!month || !day || hour === undefined) {
      console.error('Invalid date format:', dateStr);
      return null;
    }

    const now = new Date();
    let year = now.getFullYear();
    
    // Create date for this year
    let targetDate = new Date(year, month - 1, day, hour, 0, 0, 0);
    
    // If the date has already passed this year, use next year
    if (targetDate < now) {
      year++;
      targetDate = new Date(year, month - 1, day, hour, 0, 0, 0);
    }
    
    return targetDate;
  }

  getNextLoopingDate() {
    const now = new Date();
    const currentDay = now.getDay(); // 0 = Sunday, 1 = Monday, etc.
    const currentHour = now.getHours();
    
    // Convert loopingDay (1-7, 1=Monday) to JavaScript day (0-6, 0=Sunday)
    let targetDayOfWeek = this.loopingDay % 7; // 1-6 stays same, 7 becomes 0 (Sunday)
    
    let daysUntilTarget = (targetDayOfWeek - currentDay + 7) % 7;
    
    // If today is the target day, check if the time has passed
    if (daysUntilTarget === 0) {
      if (currentHour >= this.loopingHour) {
        // Time has passed today, target is next week
        daysUntilTarget = 7;
      }
    }
    
    // Create target date
    const targetDate = new Date(now);
    targetDate.setDate(targetDate.getDate() + daysUntilTarget);
    targetDate.setHours(this.loopingHour, 0, 0, 0);
    
    return targetDate;
  }

  updateCountdown() {
    const targetDate = this.getTargetDate();
    
    if (!targetDate) {
      console.warn('No valid target date found');
      this.setDisplayValues(0, 0, 0, 0);
      return;
    }

    const now = new Date();
    const timeDiff = targetDate - now;
    
    if (timeDiff <= 0) {
      this.setDisplayValues(0, 0, 0, 0);
      
      // For looping countdown, refresh to get next target
      if (this.useLooping) {
        // The interval will pick up the new target automatically
      }
      return;
    }

    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
    
    this.setDisplayValues(days, hours, minutes, seconds);
  }

  setDisplayValues(days, hours, minutes, seconds) {
    this.daysEl.textContent = String(days).padStart(2, '0');
    this.hoursEl.textContent = String(hours).padStart(2, '0');
    this.minutesEl.textContent = String(minutes).padStart(2, '0');
    this.secondsEl.textContent = String(seconds).padStart(2, '0');
  }

  destroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}

// Initialize all countdown timers on page load
document.addEventListener('DOMContentLoaded', () => {
  const countdownElements = document.querySelectorAll('[data-countdown-timer]');
  countdownElements.forEach(el => {
    el.countdownTimer = new CountdownTimer(el);
  });
});

// Reinitialize countdown timers when new content is added (e.g., after pagination)
const observer = new MutationObserver(() => {
  const countdownElements = document.querySelectorAll('[data-countdown-timer]');
  countdownElements.forEach(el => {
    // Only initialize if not already initialized
    if (!el.countdownTimer) {
      console.log('Initializing new countdown element');
      el.countdownTimer = new CountdownTimer(el);
    }
  });
});

// Observe for new countdown elements
observer.observe(document.body, {
  childList: true,
  subtree: true
});

window.addEventListener("load", function() {
  const productPageElement = document.querySelector(".product-info__block-list");
  const specsButton        = document.querySelector(".specs--block-specs summary");

  if(productPageElement && specsButton) {
    const links = productPageElement.querySelectorAll("a");
    
    for(const link of links) {
      const href = link.getAttribute("href");

      if(href && href == "#specs") {
        link.addEventListener("click", function() {
          if(!specsButton.closest("details[open]")) {
            specsButton.click();
          }
        });
      }
    }
  }
}); 